import React from "react";

const MOMENTS = [
  {
    label: "WORK",
    color: "#017bef",
    time: "Morning",
    description: "Work from a coworking space — focused, connected, productive.",
  },
  {
    label: "STAY",
    color: "#0062c0",
    time: "Evening",
    description: "Check into your hotel or apartment — everything already booked.",
  },
  {
    label: "PLAY",
    color: "#0ea5e9",
    time: "Night",
    description: "Dinner reservation confirmed — discover the city on your terms.",
  },
  {
    label: "PLAY",
    color: "#6366f1",
    time: "Next Day",
    description: "Guided outdoor experience — booked the night before through SPACIA.",
  },
];

export default function PlayYourDay() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto flex max-w-[1440px] flex-col items-center px-[16px] text-center sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">One Platform</p>
        <h2 className="pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          Your Day Doesn't End at Work
        </h2>
        <p className="max-w-[576px] pt-[16px] text-[18px] leading-7 text-[#717182]">
          SPACIA connects Work, Stay and Play so every part of your day is taken care of in one place.
        </p>

        <div className="grid w-full max-w-[896px] grid-cols-1 gap-10 pt-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-0">
          {MOMENTS.map((moment, index) => (
            <div key={moment.time} className="relative flex flex-col items-center px-[16px]">
              {/* Dashed link to the next circle (desktop only) */}
              {index < MOMENTS.length - 1 && (
                <div className="absolute left-[calc(50%+36px)] top-[27px] hidden w-[calc(100%-72px)] border-t-2 border-dashed border-[#e5e7eb] lg:block" />
              )}
              <div
                className="mb-[16px] flex size-14 items-center justify-center rounded-full text-[10px] font-bold leading-[15px] tracking-[1px] text-white drop-shadow-[0_4px_8px_rgba(0,0,0,0.12)]"
                style={{ backgroundColor: moment.color }}
              >
                {moment.label}
              </div>
              <p className="pb-1 text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-[#717182]">
                {moment.time}
              </p>
              <p className="max-w-[193px] text-[14px] leading-[22.75px] text-[#0a0a0a]">{moment.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
